import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Industry, ROUTE_PATHS } from '@/lib/index';

interface IndustryCardProps {
  industry: Industry;
}

export function IndustryCard({ industry }: IndustryCardProps) {
  return (
    <Link to={ROUTE_PATHS.INDUSTRIES}>
      <motion.div
        whileHover={{ scale: 1.02 }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      >
        <Card className="relative overflow-hidden h-80 group cursor-pointer">
          <div className="absolute inset-0">
            <img
              src={industry.image}
              alt={industry.name}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent" />
          </div>

          <div className="relative h-full flex flex-col justify-end p-6">
            <h3 className="text-2xl font-bold text-foreground mb-2">
              {industry.name}
            </h3>
            <p className="text-muted-foreground mb-4 line-clamp-2">
              {industry.description}
            </p>
            <div className="flex items-center text-primary font-semibold group-hover:gap-2 transition-all">
              <span>Learn More</span>
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </div>
          </div>
        </Card>
      </motion.div>
    </Link>
  );
}
